import { WidgetGroupList, WidgetGroupListCreate } from '@/types/dashboard'
import { inject, provide, Ref } from 'vue'
import get from 'lodash/get'
import { ActiveWidgetGroupID, getActiveDashboardData } from '@/composables/globalData/useDashoardsData'

export const GroupNavigationToken = Symbol('GroupNavigationToken')

export type TGroupNavigationProvideParams = {
    editMode?: Ref<boolean>
    activeTab?: Ref<string | number>
    onAddNewGroup?: (data?: WidgetGroupListCreate) => void
    onSwitchTab?: (newGroup: WidgetGroupList) => void
    onCopyGroup?: (newGroup: WidgetGroupList) => void
    onRemoveGroup?: (newGroup: WidgetGroupList) => void
    onUpdateGroupName?: (newName: string, widgetsGroupID: string | number) => void
    onUpdateGroupFilters?: (group: WidgetGroupList) => void
}


export function getActiveGroupTabName () {
    const activeGroup = ActiveWidgetGroupID.value
    const defaultGroup = get(getActiveDashboardData(), 'WidgetGroupList[0].WidgetGroupID')
    return activeGroup || defaultGroup
}

export function isActiveGroup (group: WidgetGroupList, activeTab: string | number = '') {
    return group.WidgetGroupID && group.WidgetGroupID.toString() === activeTab.toString()
}

export function useGroupNavigationProvide (params: TGroupNavigationProvideParams) {
    provide(GroupNavigationToken, params)
}

export function useGroupNavigationInject () {
    const injectData = inject<TGroupNavigationProvideParams>(GroupNavigationToken)

    if (!injectData) {
        throw new Error('Tabs data must be provided')
    }

    return injectData
}
